import * as React from 'reactn';
import {
    base,
    BaseColor,
    DateComponent, IBaseProps, Route, StringUtil,
    SelectComponent,
    TextComponent,
    SelectItem, Http, ComponentFactory
} from "oca-lib-web";
import {createRef} from "react";
import moment from "moment";
import Sidebar from "../component/Sidebar";
import InvokeFields from "../util/InvokeFields";
import Styles from "../style/Styles";
import VisualUtil from "../util/VisualUtil";

interface IState {
    componentFactory:ComponentFactory,
    pushNotification?:NotificationHistoryInput,
    project?:ProjectModel,
    targetTypes:Array<SelectItem>,
    targetSelections:Array<SelectItem>
}

class SendNotificationPage extends React.Component<IBaseProps, IState> {

    public pushNotificationTitleComponent = createRef<TextComponent>();
    public pushNotificationBodyComponent = createRef<TextComponent>();
    public messageComponent = createRef<TextComponent>();
    public scheduledDateComponent = createRef<DateComponent>();
    public scheduledTimeComponent = createRef<DateComponent>();
    public targetTypeComponent = createRef<SelectComponent>();
    public targetSelectionComponent = createRef<SelectComponent>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(this.global.dataManager, "createNotificationHistory", null);
        componentFactory.setHandleUpdateCallback((value:any, key:string) => {
            if (key == "appTargetType") {
                this.onTargetTypeChanged(value);
                this.forceUpdate();
            }
        })

        this.state = {
            componentFactory: componentFactory,
            pushNotification: {},
            targetTypes: [],
            targetSelections: []
        };
    }

    async componentWillMount() {
        let projectId = Route.param(this, 'projectId');
        let project = await this.global.dataManager.get("getProject", projectId);
        let targetTypes:Array<SelectItem> = [];
        if (project.pushNotificationAppTargetUrl) {
            let results = await Http.get(project.pushNotificationAppTargetUrl);
            console.log(results);
            for (let result of results) {
                targetTypes.push(result["appTargetType"]);
                //let appTargetSelection = result["appTargetSelection"];
            }
            console.log(targetTypes);
        }

        this.setState({project:project, targetTypes:targetTypes});
    }

    handleChanged(value:any, key:string) {
        //console.log(value + " " + key);
        let pushNotification = this.state.pushNotification;
        pushNotification[key] = value;

        if (key == "appTargetType") {
            this.onTargetTypeChanged(value);
        } else if (key == "pushNotificationDate") {
            //console.log(moment(value).format("YYYY-MM-DD"));
            pushNotification[key] = moment(value).format("YYYY-MM-DD");
        } else if (key == "pushNotificationTime") {
            //console.log(moment(value).format("HHmm"));
            pushNotification[key] = moment(value).format("HHmm");
        }

        this.setState({pushNotification:pushNotification});
    }

    async onTargetTypeChanged(value:string) {
        let targetSelections:Array<SelectItem> = [];
        //if (project.pushNotificationAppTargetUrl) {
            let results = await Http.get(this.state.project.pushNotificationAppTargetUrl);
            console.log(results);
            for (let result of results) {
                let appTargetType = result["appTargetType"];
                if (appTargetType.value == value) {
                    console.log("found value: " + value);
                    targetSelections = result["appTargetSelection"];
                }
            }

            this.setState({targetSelections:targetSelections})
        //}
    }

    async saveButtonTapped() {
        //let user = await AWSAuth.getCurrentAuthenticatedUser();
        //let user = await DataAccess.getCurrentUser();

        // Send notification history
        //let pushNotificationHistory = this.state.pushNotification;
        let pushNotificationHistory = this.state.componentFactory.getDefaultBinding().item;
        pushNotificationHistory.id = StringUtil.uuid();
        pushNotificationHistory.date = moment().format();
        pushNotificationHistory.numberOfDevices = 0;
        pushNotificationHistory.completed = false;
        pushNotificationHistory.projectId = this.state.project.id;

        console.log(pushNotificationHistory);
        let createdPushNotification = await this.global.dataManager.save("createNotificationHistory", pushNotificationHistory);

        let sendPushNotificationInput:PushNotificationInput = {
            notificationHistoryId: createdPushNotification.id,
            field: InvokeFields.sendPushNotifications
        };

        this.global.dataManager.perform("sendPushNotifications", sendPushNotificationInput);

        Route.goBack(this);
    }

    public render() {
        const cf = this.state.componentFactory;
        let pushNotificationTitle = cf.getDefaultBinding().getProperty("pushNotificationTitle");
        let pushNotificationBody = cf.getDefaultBinding().getProperty("pushNotificationBody");
        let appTargetType = cf.getDefaultBinding().getProperty("appTargetType");

        return (
            cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE}, [
                cf.renderBoxProps({marginLeft:'70px'}, [
                    VisualUtil.getHeaderDisplay("Notification Details", cf.renderButton("Save Changes", this.saveButtonTapped.bind(this))),
                    cf.renderLine(),
                    cf.renderBoxPadded(cf.renderTextField("pushNotificationTitle", "Notification Title (" + (pushNotificationTitle ? pushNotificationTitle.length : "0") + "/50)", this.pushNotificationTitleComponent, null, {maxLength:50, required:true})),
                    cf.renderBoxPadded(cf.renderTextField("pushNotificationBody", "Notification Message (" + (pushNotificationBody ? pushNotificationBody.length : "0") + "/160)", this.pushNotificationBodyComponent, null, {maxLength:160, required:true})),
                    cf.renderBoxPadded(cf.renderDateField("pushNotificationDate", "Scheduled Date", "date", this.scheduledDateComponent)),
                    cf.renderBoxPadded(cf.renderDateField("pushNotificationTime", "Scheduled Time", "time", this.scheduledTimeComponent)),
                    cf.renderLine(),
                    VisualUtil.getHeaderDisplay("Targeting"),
                    cf.renderLine(),
                    cf.renderBoxPadded(cf.renderSelectField("appTargetType", "Target Type", this.state.targetTypes, this.targetTypeComponent, null, {required:true})),
                    appTargetType == "custom" ? cf.renderBoxPadded(cf.renderTextField("appTargetCustom", "Custom Target")) : cf.renderBoxPadded(cf.renderSelectField("appTargetSelection", "Target Asset", this.state.targetSelections, this.targetSelectionComponent, null, {required:true}))
                ])
            ])
        )
    }
}

export default base(SendNotificationPage, Sidebar)